export const buildNavItems = (assetTypeId: string) => {
  return [
    {
      route: `/asset-management/asset-type/${assetTypeId}`,
      label: "General Infos"
    },
    {
      route: `/asset-management/asset-type/assets/${assetTypeId}`,
      label: "Assets"
    }
  ];
};

export const getAssetDetailNavigationItems = (assetId: string) => {
  return [
    {
      route: `/asset-management/asset/${assetId}`,
      label: "General Infos"
    }
  ];
};

export const getFeatureToggleDetailNavigationItems = (environment: string, featureId: string) => {
  return [
    {
      route: `/feature-toggles/${environment}/${featureId}/details`,
      label: "Details"
    },
    {
      route: `/feature-toggles/${environment}/${featureId}/changelog`,
      label: "Changelog"
    }
  ];
};
